import React, { useEffect, useState } from "react"
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
} from "@mui/material"

import * as Style from "./style"
import { Link, useNavigate } from "react-router-dom"
import Select from "@mui/material/Select"
import {
  useAccountProfileQuery,
  useGetAvailablePostQuery,
} from "../../features/Auth/authApi"

import dummy from "../../images/dummy-image.jpg"
import { TbArrowsSort } from "react-icons/tb"
import CenteredSpinner from "../common/CenteredSpinner"
import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
} from "../common/utctolocalDate"
import RatingStars from "../common/rating"
import { MdOutlineLocationOn } from "react-icons/md"
import { useAppDispatch } from "../../app/store"
import { appliedPostKey, setnPagesElect } from "../../features/Auth/authSlice"
import noData from "../../images/no-results.svg"
import { useAppSelector } from "../../app/hooks"

const MyJobs = () => {
  const [personName, setPersonName] = React.useState<String>()
  const [pageSelect, setPageSelect] = useState<string>("")
  const [selectedPage, setSelectedPage] = useState(0)
  const [dateShortList, setDateListShort] = useState(1)
  const { data: serviceDetails } = useAccountProfileQuery({})
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const pageNoSelected = useAppSelector((state) => state.auth.pagesElect)

  const handleChange = (event: any, name: any) => {
    if (name == "service") {
      setPersonName(event.target.value)
    } else if (name == "page") {
      setPageSelect(event.target.value)
    } else {
      setSelectedPage(null as any)
    }
  }

  const handlePageChange = (event: any, value: any) => {
    setSelectedPage(value)
  }

  useEffect(() => {
    dispatch(setnPagesElect(selectedPage as any))
  }, [selectedPage])

  const {
    data: availabeJobs,
    isLoading,
    isFetching,
  } = useGetAvailablePostQuery({
    serviceId: personName == "All" ? "" : personName,
    pageNo: pageNoSelected,
    pageLimit: pageSelect,
    createdAt: dateShortList,
  })

  const handleDateShort = () => {
    const newValue = dateShortList === 1 ? -1 : 1
    setDateListShort(newValue)
  }

  useEffect(() => {
    setPageSelect(availabeJobs?.totalDocument?.pageLimit?.toString())
    if (pageNoSelected) {
      setSelectedPage(pageNoSelected)
    }
  }, [pageNoSelected, availabeJobs])

  return (
    <>
      <Style.Overview>
        <Box>
          <Box className="d-flex flex-column flex-lg-row align-items-center justify-content-between">
            <Box className="d-flex flex-none w-100 max-w-550 mt-3 mt-md-5 mb-3 mb-lg-0"></Box>
            <Box className="d-flex flex-column flex-lg-row w-100 align-items-stretch align-items-lg-center me-2 gap-lg-5">
            <div className="w-100 me-0 me-md-2 mb-3 mb-md-0 display-contents">
              <FormControl
                sx={{
                  m: 1,
                  mt: { xs: 1, md: 3 },
                  minWidth: { xs: "100%", md: 250 },
                  width: { xs: "calc(100% - 16px)", md: "auto" },
                }}
                className="custom-field"
              >
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ backgroundColor: "#fff" }}
                >
                  Services
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label "
                  id="demo-simple-select"
                  value={personName}
                  onChange={(event) => handleChange(event, "service" as any)}
                  sx={{ textAlign: "left" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        width: 300,
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#f07fa9 transparent",
                        borderRadius: "12px",
                        cursor: "pointer",
                      },
                    },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                  }}
                >
                  <MenuItem 
                    value={"All"}
                    sx={{
                      whiteSpace: "normal", 
                      "&:hover": {
                        backgroundColor: "#bfdbff !important",
                        color: "#050505",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#f475A4 !important", 
                        color: "#fff",
                      },
                      "&.Mui-focused, &.Mui-active, &:active": {
                        backgroundColor: "#f475A4",
                      },
                    }}
                  >
                    {"All"}
                  </MenuItem>
                  {serviceDetails?.data?.services?.map((item: any) => (
                    <MenuItem 
                      key={item?._id} 
                      value={item?._id}
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        "&:hover": {
                          backgroundColor: "#bfdbff !important",
                          color: "#050505",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#f475A4 !important",
                          color: "#fff",
                        },
                        "&.Mui-focused, &.Mui-active, &:active": {
                          backgroundColor: "#f475A4",
                        },
                      }}
                    >
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div className="w-100 display-contents">
              <FormControl
                sx={{ 
                  m: 1, 
                  maxWidth: { xs: "100%", md: 200 }, 
                  mt: { xs: 1, md: 3 },
                  width: { xs: "calc(100% - 16px)", md: "auto" },
                }}
                className="custom-field view-field"
              >
                <InputLabel 
                  id="demo-simple-select-label"
                  sx={{
                    backgroundColor: "#f9f9f9",
                    px: 0.5,
                    zIndex: "10"
                  }}
                >
                  View
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={pageSelect}
                  onChange={(event) => handleChange(event, "page" as any)}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Box>
</Box>
          {availabeJobs?.data?.length > 0 && (
            <Box>
              <Typography align="left" variant="h2" mt={2}>
                Jobs For You
              </Typography>
            </Box>
          )}
          <Box>
            <Style.Overview>
              <TableContainer
                component={Paper}
                className="dashboard-table-wrapper custom-scrollbar "
              >
                <Table
                  sx={{
                    marginBottom: "20px",
                    minWidth: 650,
                    border: "none",
                    backgroundColor: "transparent",
                    position: "relative",
                  }}
                  className="dashboard-table "
                  aria-label="simple table"
                >
                  {availabeJobs?.data?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <TableCell align="center"></TableCell>

                        <TableCell align="center">Name</TableCell>
                        <TableCell align="center">Service Required</TableCell>

                        <TableCell align="center">Phone Number</TableCell>
                        <TableCell align="center">
                          Location <MdOutlineLocationOn />
                        </TableCell>
                        <TableCell align="center" onClick={handleDateShort}>
                          Starts On <TbArrowsSort />
                        </TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                  )}

                  {isLoading ? (
                    <CenteredSpinner />
                  ) : (
                    <TableBody>
                      {availabeJobs?.data?.length > 0 ? (
                        availabeJobs?.data?.map((row: any) => (
                          <TableRow
                            key={row.serviceseeker}
                            sx={{
                              backgroundColor: "#fff",
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate(
                                `/dashboard/job-detail/${
                                  row?._id
                                }?type=${"applied-job"}`,
                                dispatch(appliedPostKey(null as any)) as any,
                              )
                            }}
                          >
                            <TableCell>
                              <div
                                style={{
                                  width: "74px",
                                  height: "74px",
                                  objectFit: "cover",
                                }}
                              >
                                <img
                                  src={row.seekerData?.profilePic || dummy}
                                  alt="User"
                                  style={{
                                    width: "74px",
                                    height: "74px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            </TableCell>

                            <TableCell
                              component="td"
                              align="center"
                              scope="row"
                            >
                              <span className="text flex-column gap-2">
                                {row.seekerData?.name + " "}
                                {row?.seekerData?.rating?.$numberDecimal !==
                                "0" ? (
                                  <span className="minh-1">
                                    <RatingStars
                                      rating={
                                        row?.seekerData?.rating?.$numberDecimal
                                      }
                                    />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                            </TableCell>

                            <TableCell align="center">
                              <Tooltip title={row?.service?.name || ""} arrow>
                                <span>
                                  {(row?.service?.name || "").length > 20
                                    ? row?.service?.name.slice(0, 20) + "..."
                                    : row?.service?.name}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell align="center">
                              <span>{row?.seekerData?.contactNo}</span>
                            </TableCell>

                            <TableCell align="center">
                              <span className="location custom-scrollbar overflow-auto">
                                <Tooltip title={row.location}>
                                  <p
                                    style={{
                                      display: "flex",
                                      maxWidth: 150, // adjust as needed
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      verticalAlign: "bottom",
                                      textAlign: "center",
                                      margin: "0px",
                                    }}
                                  >
                                    {row.location}
                                  </p>
                                </Tooltip>
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              <span className="datetime">
                                <span className="d-flex flex-column">
                                  <span className="weekday">
                                    <FormatDate dateString={row?.from} />
                                  </span>

                                  <span>
                                    <FormatChangeTime dateString={row?.from} />
                                  </span>
                                  <span>
                                    <FormatTime dateString={row?.from} />
                                  </span>
                                </span>
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              <span>
                                <Link
                                  to={`/dashboard/job-detail/${row?._id}`}
                                  className="view-profile"
                                  onClick={() =>
                                    dispatch(appliedPostKey(null as any))
                                  }
                                >
                                  Apply
                                </Link>
                              </span>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow
                          sx={{
                            height: "50vh",
                            backgroundColor: "white",
                          }}
                        >
                          {" "}
                          <TableCell
                            align="center"
                            colSpan={7}
                            sx={{
                              width: "100%",
                              pointerEvents: "none",
                              border: "none",
                            }}
                          >
                            <img
                              src={noData}
                              style={{
                                width: "100%",
                                maxWidth: "180px",
                              }}
                            />
                            <span
                              className="no-data-text"
                              style={{
                                fontSize: "20PX",
                                fontWeight: "600",
                                color: "#000",
                              }}
                            >
                              No Data Found
                            </span>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {availabeJobs?.data?.length > 0 && (
                <Box className="d-md-flex justify-content-between mt-2">
                  <Typography variant="body1" className="w-auto white-space">
                    {" "}
                    Showing {availabeJobs?.totalDocument?.showingData} -{" "}
                    {availabeJobs?.totalDocument?.showingEnd}
                  </Typography>
                  <Grid container justifyContent="flex-end">
                    <Grid item md={3}>
                      <Box display="flex" className="flex-column">
                        <Stack spacing={2} className="mb-3">
                          <Pagination
                            count={availabeJobs?.totalDocument?.totalPages}
                            color="secondary"
                            className="custom-pagination "
                            page={availabeJobs?.totalDocument?.pageNo}
                            onChange={handlePageChange}
                            sx={{
                              "& .MuiPaginationItem-page.Mui-selected": {
                                backgroundColor: "#F475A4",
                                boxSizing: "border-box",
                              },
                              "& .css-wjh20t-MuiPagination-ul": {
                                flexWrap: "nowrap",
                                justifyContent: "end",
                              },
                              "& .css-nhb8h9": {
                                flexWrap: "nowrap",
                                justifyContent: "end",
                              },
                            }}
                          />
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Style.Overview>
          </Box>
        </Box>
      </Style.Overview>
    </>
  )
}

export default MyJobs
